import { render } from "./QuoteDetailPage.vue?vue&type=template&id=278bd2b8&scoped=true"
import script from "./QuoteDetailPage.vue?vue&type=script&lang=js"
export * from "./QuoteDetailPage.vue?vue&type=script&lang=js"

import "@/css/CreateQuotePage.css?vue&type=style&index=0&lang=css&external"
import "./QuoteDetailPage.vue?vue&type=style&index=1&id=278bd2b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-278bd2b8"]])

export default __exports__